export class WorkitemsFromQueueOutput{
    public assignedAgent:Array<any>;
    public createTms:string;
    public completedTms:string;
    public workItemId:number;
    public workItemStatus:string;
    public workItemType:string;
    
}